import React, { useEffect, useState } from 'react';
import { useResponsive } from '../../../hooks/useResponsive';

import { Contact } from '../../../app/entities/contact';
import { ContactWithPreview } from './contact-with-preview';
import { ContactSearchBar } from './contact-search.bar';
import { searchContacts } from './utils/search-contacts';

import styles from './contact-list.module.scss';
export type ContactListProps = {
  contacts: Contact[];
};

export const ContactList: React.FC<ContactListProps> = ({ contacts }) => {
  const [searchValue, setSearchValue] = useState('');
  const [filteredContacts, setFilteredContacts] = useState<Contact[]>(contacts);
  const { isMobile } = useResponsive();

  useEffect(() => {
    setFilteredContacts(searchContacts(contacts, searchValue));
  }, [searchValue, contacts]);

  return (
    <div className={styles['container']}>
      {isMobile && (
        <div className={styles['contact-search-bar-wrapper']}>
          <ContactSearchBar onChange={setSearchValue} key="search-contacts" value={searchValue} />
        </div>
      )}

      {filteredContacts?.map((contact) => (
        <ContactWithPreview key={contact._id} contact={contact} />
      ))}
    </div>
  );
};
